import { newDateTimezoneOffset } from '@schooly/utils/date';
import { differenceInYears } from 'date-fns';

export const getAge = (dob: string, referenceDate?: string) => {
  const date = referenceDate ? newDateTimezoneOffset(referenceDate) : new Date();

  return differenceInYears(date, newDateTimezoneOffset(dob));
};
